import { AbstractControl, ValidationErrors } from '@angular/forms';

export function futureDateTimeValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) { return null; }
  const date = new Date(control.value + 'Z');
  if (isNaN(date.getTime()) || date.getUTCFullYear() < 1900) {
    return { invalidDateTime: true };
  }
  return date.getTime() > Date.now() ? null : { pastDateTime: true };
}

export function minDateTimeLocal(): string {
  return new Date().toISOString().slice(0, 16);
}
